const chatInputBorderRadius = 'medium' as const;

const chatInputMaxTextAreaHeight = 200;

const chatInputSuggestionCycleInterval = 4000;

export { chatInputBorderRadius, chatInputMaxTextAreaHeight, chatInputSuggestionCycleInterval };
